/* eslint-disable no-unused-vars */
import { useMutation } from '@apollo/client';
import { Button, Col, Form, Input, InputNumber, Modal, Row } from 'antd';
import { trim, upperCase } from 'lodash';
import { useEffect } from 'react';
import { PACKAGING_TYPES } from '../../common/constants';
import { CREATE_PRODUCT_PACKAGING, UPDATE_PRODUCT_PACKAGING } from './graphql/Mutations';

function AddEditModal({
  isModalOpen,
  setIsModalOpen,
  refetch,
  selectedRecord,
  setSelectedRecord,
}) {
  const [form] = Form.useForm();

  const [productPackagingMutation, { loading }] = useMutation(
    selectedRecord ? UPDATE_PRODUCT_PACKAGING : CREATE_PRODUCT_PACKAGING,
    {
      onCompleted() {
        setSelectedRecord();
        setIsModalOpen(false);
      },
      onError: () => { },
    },
  );

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue({
        productName: selectedRecord.productName,
        quantity: selectedRecord.quantity,
        packagingBindis: selectedRecord.packagingBindis || PACKAGING_TYPES.map(type => ({ key: type.key, qty: 0 })),
      });
    } else {
      form.resetFields();
    }
  }, [selectedRecord, form]);

  const onFinish = async (values) => {
    // Clean packagingBindis data by removing __typename and other Apollo metadata
    const cleanPackagingBindis = (values?.packagingBindis || []).map(bindi => ({
      key: bindi.key,
      qty: Number(bindi.qty) || 0,
    }));

    productPackagingMutation({
      variables: {
        input: {
          productName: trim(values?.productName),
          quantity: values?.quantity,
          packagingBindis: cleanPackagingBindis,
        },
        ...(selectedRecord && {
          where: { id: selectedRecord?.id },
        }),
      },
    });

    refetch();
  };


  return (
    <div id="add-edit-product-packaging-modal">
      <Modal
        centered
        title={
          <h3 className="m-0 mb-10">
            {upperCase(`${selectedRecord ? 'Edit' : 'Add New'} Product Packaging`)}
          </h3>
        }
        footer={null}
        onCancel={() => {
          setSelectedRecord();
          setIsModalOpen(false);
        }}
        open={isModalOpen}
        width={800}
        maskClosable={false}
      >
        <Form
          form={form}
          name="basic"
          initialValues={
            selectedRecord
              ? {
                ...selectedRecord,
                packagingBindis: selectedRecord.packagingBindis || PACKAGING_TYPES.map(type => ({ key: type.key, qty: 0 })),
              }
              : {
                packagingBindis: PACKAGING_TYPES.map(type => ({ key: type.key, qty: 0 })),
              }
          }
          className="product-packaging-forms mt-16"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                label="Product Name"
                name="productName"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Please input product name!',
                  },
                ]}
              >
                <Input placeholder="Enter product name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Quantity"
                name="quantity"
                rules={[
                  {
                    required: true,
                    message: 'Please input quantity!',
                  },
                ]}
              >
                <InputNumber
                  placeholder="Enter quantity"
                  style={{ width: '100%' }}
                  min={0}
                  step={1}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Packaging Bindis">
            <Form.List name="packagingBindis">
              {(fields) => (
                <>
                  {PACKAGING_TYPES.map((packagingType, index) => (
                    <Row key={packagingType.key} gutter={[16, 8]} align="middle" className="dynamic-packaging-item">
                      <Col xs={24} sm={12} span={12}>
                        <Form.Item
                          name={[index, 'key']}
                          initialValue={packagingType.key}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            value={packagingType.label}
                            disabled
                            style={{ backgroundColor: '#f5f5f5' }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} span={12}>
                        <Form.Item
                          name={[index, 'qty']}
                          rules={[
                            { required: true, message: 'Enter quantity!' },
                            { type: 'number', min: 0, message: 'Quantity must be greater than or equal to 0!' },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <InputNumber
                            placeholder="No of bindi"
                            style={{ width: '100%' }}
                            min={0}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            className="full-width font-600 submit-btn"
            disabled={loading}
            loading={loading}
          >
            {selectedRecord ? `Edit` : `Add`} Product Packaging
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default AddEditModal;